import React from 'react';
import { Button } from 'antd';

import { AnalyticsQueryExport, TFilters } from '../services/interfaces';
import { downloadContentAnalytics } from '../utils/downloadContentAnalytics';

type Props = {
    readonly type: AnalyticsQueryExport;
    readonly filters?: TFilters;
};
export const DownloadButton = ({ filters, type }: Props) => {
    return (
        <Button onClick={() => downloadContentAnalytics(filters, type)}>
            Скачать
        </Button>
    );
};
